<script setup>
  import Breadcrumbs from './BreadCrumbs.vue'
  import Footer from './FooterSection.vue'
  import { ref, onMounted } from 'vue'
  import { useTemplateVariablesStore } from '../stores/TemplateVariablesStore'

  const templateStore = useTemplateVariablesStore()
  const { getDefinitionById } = templateStore
  // const customNavigation = inject('customNavigation')
  const termsAndConditions = ref({ body: '' })

  onMounted(async () => {
    termsAndConditions.value = await getDefinitionById('termsAndConditions')
  })
</script>

<template>
  <div class="mt-4 help-resources-container bcs-page-padding">
    <div class="row mb-3">
      <div class="col-8">
        <Breadcrumbs class="mb-4"></Breadcrumbs>
        <h1 class="text-28 mb-3 terms-and-conditions-title">Terms & Conditions</h1>
        <h2 class="text-16 terms-and-conditions-subtitle">
          <strong>
            In using this site you are deemed to have read and agreed to the following terms and
            conditions:
          </strong>
        </h2>
      </div>
    </div>

    <div class="row terms-and-conditions-content-row">
      <div class="text-14 terms-and-conditions-content-column">
        <div v-html="termsAndConditions.body"></div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</template>

<style scoped>
  .terms-and-conditions-title {
    margin-top: 1.7rem;
    margin-left: 0.5rem;
  }

  .terms-and-conditions-subtitle {
    margin-top: 1.55rem;
    margin-left: 0.75rem;
  }

  .terms-and-conditions-content-row {
    margin-left: 0.09rem;
  }

  .terms-and-conditions-content-column {
    width: calc(58.33333333% + 10rem);
    max-width: calc(58.33333333% + 10rem);
  }

  .view-full-profile-link {
    position: relative;
    float: right;
    margin-top: 5px;
  }

  .add-teamates-link {
    display: contents;
  }
</style>
